module.exports = __webpack_public_path__ + "static/callout-5aae4a419a7178bc74f4d747016f99f6.jpg";